import { formEncode, handleResponse, nextJsonApi } from '@/API/core';

const auth = {
  login: async (data: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post('/auth/login', formEncode(data));
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  sendOtp: async (data: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post(
        '/auth/login/send-otp',
        formEncode(data)
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  verifyOtp: async (data: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post(
        '/auth/login/verify-otp',
        formEncode(data)
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  sendForgotPasswordOtp: async (data: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post('/auth/forgot-password/send-otp', data);
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  resetForgotPassword: async (data: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post('/auth/forgot-password/reset', data);
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  verifyForgotPasswordOtp: async (data: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post(
        '/auth/forgot-password/verify-otp',
        data
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  refreshToken: async (adminId: string, token: string) => {
    let response = null;
    try {
      response = await nextJsonApi.get(
        `/auth/refresh-token?admin_id=${adminId}&token=${token}`
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  getUserContext: async (data: {
    admin_id: string;
    assumed_user_id?: string;
    selected_company_id?: string;
  }) => {
    let response = null;
    try {
      response = await nextJsonApi.post('/auth/context', data);
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default auth;
